import * as types from "../types/rider.types";
import { getRiderList, 
  getRidersFiltersPagination, 
  refreshTookanData, 
  getRiderDetail, 
  riderBatchAssign,
  riderZoneAssign, 
  riderApprove,
  riderBlock,
  RiderOngoingShift,
  postRiderBrake,
  getRidersByZone,
  patchRiderSuspendStatus,
  patchRiderSyncRms
} from '../../services/riders.service';
import { validationErrors } from "../../utils/Helpers";

export const getRiderListAction = (data, navigate) => {
  return async (dispatch, getState)  => {
    try {
      await getRiderList(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        if(res.data.code === 200){
          dispatch({
            type: types.SET_RIDER_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const getRidersFiltersPaginationAction = (data, navigate) => {
  return async (dispatch, getState)  => {
    try {
      await getRidersFiltersPagination(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
        if(res.data.code === 200){
          dispatch({
            type: types.SET_RIDER_DATA,
            payload: res.data.data,
          });
          dispatch({
            type: types.SET_RIDER_PAGINATION,
            payload: res.data.pagination,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const refreshTookanDataAction = (data, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    await refreshTookanData(getState().authReducer.token, getState().authReducer.user.id, data).then((res) => {
      if(res.data.code === 200){
        request_status = true;
        return_data['status'] = true;
        return_data['message'] = res.data.message;
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const getRiderDetailAction = (data, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    await getRiderDetail(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        request_status = true;
        return_data['status'] = true;
        return_data['data'] = res.data.data;
        dispatch({
          type: types.SET_RIDER_DETAIL_DATA,
          payload: res.data.data,
        });
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const riderBatchAssignAction = (data, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    await riderBatchAssign(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        request_status = true;
        return_data = true;
        dispatch({
          type: types.SET_RIDER_DETAIL_DATA,
          payload: res.data.data,
        });
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const riderZoneAssignAction = (data, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    await riderZoneAssign(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        request_status = true;
        return_data = true;
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const riderApproveAction = (data, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    await riderApprove(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        request_status = true;
        return_data = true;
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const riderBlockAction = (data, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    await riderBlock(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        request_status = true;
        return_data = true;
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const RiderOngoingShiftAction = (data, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];

  try {
    await RiderOngoingShift(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        request_status = true;
        return_data['status'] = true;
        return_data['data'] = res.data.data;
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const postRiderBrakeAction = (data, navigate) => async (dispatch, getState) => {
  let request_status = false;
  let return_data = [];
  try {
    await postRiderBrake(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
      if(res.data.code === 200){
        request_status = true;
        return_data['status'] = true;
        return_data['data'] = res.data.data;
        return_data['message'] = res.data.message;
      }
    });
  } catch (e) {
    validationErrors(e);
  }
  if (request_status) return return_data;
  else return false;
};

export const getRidersByZoneAction = (data) => {
  return async (dispatch, getState)  => {
    try {
      await getRidersByZone(data, getState().authReducer.token, getState().authReducer.user.id).then((res) => {
        if(res.data.code === 200){
          dispatch({
            type: types.SET_RIDER_DATA,
            payload: res.data.data,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    }
  };
};


export const RiderSuspendStatusAction = (data) => {
  return async (dispatch, getState) => {
    try {
      return patchRiderSuspendStatus(getState().authReducer.token, getState().authReducer.user.id, data);
    } catch (e) {
      validationErrors(e);
    }
  };
};

export const RiderSyncRmsAction = (data) => {
  return async (dispatch, getState) => {
    try {
      return patchRiderSyncRms(getState().authReducer.token, getState().authReducer.user.id, data);
    } catch (e) {
      validationErrors(e);
    }
  };
};